















































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { WorkProgressState } from "@/model/WorkProgressState";
import { WorkProgressStateData } from "@/model/WorkProgressStateData";
import * as util from "@/service/util";
import InputNumber from "@/components/common/input/InputNumber.vue";
import { padNumber } from "@/service/util";
import ReservationDetailState from "@/store/reservation/state";
import requestService from "@/service/requestService";
import { MESSAGE } from "@/model/Message";
import { Staff } from "@/model/Staff";
import ConfirmDialog from "@/components/common/ConfirmDialog.vue";
import { CustomerService } from "@/service/CustomerService";
import { SubHeaderData } from "@/model/SubHeaderData";
import { InspectTime } from "@/model/InspectTime";
import { UserService } from "@/service/UserService";
import { SocketControllers } from "@/service/SocketControllers";
import { CarSelectData } from "@/model/CarSelection";
import Number from "@/shared/filters/Number";
import { ElButton } from "element-ui/types/button";
import SknMenuDialog from "@/components/sknMenuDialog.vue";
import { InspectDetail } from "@/model/InspectDetail";
import { Buhin } from "@/model/Buhin";

const reservationStoreNm: string = "ReservationDetail";
const inspectStoreNm = "InspectionDetail";
@Component({
  components: {
    InputNumber,
    ConfirmDialog
    , SknMenuDialog
  },
  filters: {
    Number
  }
})
export default class SubHeader extends Vue {
  @Prop({ default: false })
  canEditSoukou: boolean;
  @Getter("currentState", { namespace: reservationStoreNm })
  reservationState: ReservationDetailState;

  @Getter("inspectTime", { namespace: "SubHeader" })
  inspectTime: number;
  @Getter("isInspecting", { namespace: "SubHeader" })
  isInspecting: boolean;
  @Getter("maintenanceTime", { namespace: "SubHeader" })
  maintenanceTime: number;
  @Getter("maintenanceExpectTime", { namespace: "SubHeader" })
  maintenanceExpectTime: number;
  @Getter("stateId", { namespace: "SubHeader" })
  stateId: number;
  @Getter("stateNm", { namespace: "SubHeader" })
  stateNm: string;

  @Action("setSubHeaderData", { namespace: "SubHeader" })
  setSubHeaderData: any;

  @Action("updateOmonaYouto", { namespace: reservationStoreNm })
  updateOmonaYouto: any;
  @Action("updateSoukouKm", { namespace: reservationStoreNm })
  updateSoukouKm: any;
  @Action("updateSoukouKmAvg", { namespace: reservationStoreNm })
  updateSoukouKmAvg: any;
  @Action("updateSoukouMile", { namespace: reservationStoreNm })
  updateSoukouMile: any;
  @Action("updateSoukouMileAvg", { namespace: reservationStoreNm })
  updateSoukouMileAvg: any;
  @Action("updateSoukouUnitKbn", { namespace: reservationStoreNm })
  updateSoukouUnitKbn: any;
  @Action("updateSoukouBikouKbn", { namespace: reservationStoreNm })
  updateSoukouBikouKbn: any;
  @Action("updateFrontStaff", { namespace: reservationStoreNm })
  updateFrontStaff: any;
  @Getter("uketsukeCd", { namespace: reservationStoreNm })
  uketsukeCd: any;
  @Getter("uketsukeExtendsId", { namespace: reservationStoreNm })
  uketsukeExtendsId: number;

  @Getter("waitPartsSelect", { namespace: "SubHeader" })
  waitPartsSelect: boolean;

  @Action("updateWaitPartSelect", { namespace: "SubHeader" })
  updateWaitPartSelect: any;

  @Getter("isSavePayment", { namespace: "SubHeader" })
  isSavePayment: boolean;

  @Getter("currentState", { namespace: "CarSelection" })
  carSelectData: CarSelectData;

  @Action("setState", { namespace: "CarSelection" })
  setCarSelection: any;

  @Action("setInspectTime", { namespace: "SubHeader" })
  setInspectTime: any;

  @Action("setMaintenanceTime", { namespace: "SubHeader" })
  setMaintenanceTime: any;

  @Action("clearState", { namespace: "Buhin" })
  clearBuhin: any;
  @Action("setSeibiMenuCd", { namespace: "InspectionDetail" })
  setSeibiMenuCd: any;

  omonaYoutos: any[] = [];
  inspectMinute: string = "000";
  // inspectMinuteNum: number = 0;
  inspectTimer: any;
  maintenanceMinute: string = "算出中";
  maintenanceMinuteNum: number = 0;
  maintenanceTimer: any;
  omonaYoutoCd: any = null;
  omonaYoutoNm: string = "";
  reqService: requestService;
  sktControll: SocketControllers;
  kyotenCd: string = "";
  staffs: Staff[] = [];
  isUserMode: boolean = false;
  errorMsg: string = "";
  service: CustomerService;
  isNotStartMaintenance: boolean = true;
  isMaintenanceOverExpect: boolean = false;
  isSaveYouto: boolean = false;
  timerCheckSocket: any = null;
  timerManualUpdateTime: any = null;

  isExceed: boolean = false;
  tempKm: any = null;
  tempMile: any = null;
  displayDialogCompleted: boolean = false;

  shakenShurui: any = [];
  seibiMenuCd: string = "";

  $refs!: {
    errorDialog: ConfirmDialog;
    md15FinishDialog: ConfirmDialog;
    sknMenuDialog: SknMenuDialog;
    dialog: ConfirmDialog;
  };

  // @Watch("$route")
  // onRouteChange(to: any, from: any) {
  //   this.checkPage(to.name);
  // }

  // checkPage(route: string) {
  //   if (route === "carselection") {
  //     this.isViewSoukouOnly = false;
  //   } else {
  //     this.isViewSoukouOnly = true;
  //   }
  // }

  created() {
    const kyoten = window.localStorage.getItem("kyotenCd");
    if (kyoten) {
      this.kyotenCd = kyoten;
    }
    this.service = new CustomerService();
    if (this.$route.meta == "user") {
      this.isUserMode = true;
    }
    this.sktControll = new SocketControllers();
    this.sktControll.connectSocket(this.onConnect);
    this.reqService = new requestService();

    if (this.isUserMode) {
      this.timerCheckSocket = setTimeout(() => {
        this.timerCheckSocket = null;
        if (!this.sktControll.checkSocket()) {
          this.timerManualUpdateTime = setInterval(() => {
            this.getSubHeaderData();
          }, 50000);
        }
      });
    }

    this.getSubHeaderData();

    this.reqService.getKbnSkns("skn_shiyou_youto").then((res: any) => {
      if (res && res.length > 0) {
        this.omonaYoutos = res;
      }
    });
    this.setSoukouAvg();
    this.saveTempSoukou();
    if (this.sknUketsukeExtends && this.sknUketsukeExtends.omonaYouto) {
      this.omonaYoutoCd = this.sknUketsukeExtends.omonaYouto;
    }

    if (this.sknUketsukeExtends && this.sknUketsukeExtends.omonaYoutoNm) {
      this.omonaYoutoNm = this.sknUketsukeExtends.omonaYoutoNm;
    }

    this.reqService.getStaffs(this.kyotenCd).then((staffs: any) => {
      if (staffs) {
        this.staffs = staffs;
        if (
          this.sknUketsukeExtends &&
          this.sknUketsukeExtends.frontTantoushaCd
        ) {
          this.onUpdateFront(this.sknUketsukeExtends.frontTantoushaCd);
        }
      }
    });
  }

  getSubHeaderData() {
    this.reqService
      .getSubHeaderData(this.uketsukeExtendsId, this.$route.meta)
      .then(
        (res: SubHeaderData) => {
          this.setSubHeaderData(res);
          this.setInspectMinute();
          this.setMaintenanceMinute();
        },
        (err: any) => {}
      );
  }

  get uketsuke() {
    if (this.reservationState && this.reservationState.uketsuke) {
      return this.reservationState.uketsuke;
    }
    return {};
  }

  get sknUketsukeExtends() {
    if (this.reservationState) {
      return this.reservationState.sknUketsukeExtends;
    }
    return {};
  }

  get customer() {
    if (this.reservationState) {
      return this.reservationState.customer;
    }
    return {};
  }

  get customerCar() {
    if (this.reservationState) {
      return this.reservationState.customerCar;
    }
    return {};
  }

  get modelNm() {
    if (this.uketsuke) {
      return this.uketsuke.srModelNm;
    }
    return "";
  }

  get customerName() {
    if (this.uketsuke) {
      if (this.IsHoujin) {
        if (this.uketsuke.kkHoujinNmKj) {
          return this.uketsuke.kkHoujinNmKj;
        }
      } else {
        let kknm = "";
        if (this.uketsuke.kkNmL) {
          kknm = this.uketsuke.kkNmL;
        }
        if (this.uketsuke.kkNmF) {
          kknm += " " + this.uketsuke.kkNmF;
        }
        return kknm;
      }
    }
    return "";
  }

  get nyuukoRireki() {
    if (this.uketsuke && this.uketsuke.nyuukoRireki) {
      return this.uketsuke.nyuukoRireki;
    }
    return "なし";
  }

  get nenshiki() {
    let format = "YYYYMM";
    if (this.customerCar && this.customerCar.nenshiki) {
      if (this.customerCar.nenshiki.length === 4) {
        format = "YYYY";
      }
      return util.getJapanDate(this.customerCar.nenshiki, format);
    }
    return "";
  }

  get torokubango(): string {
    if (this.uketsuke) {
      let srPlateAreaNm = "";
      let srPlateModelNm = "";
      let srPlateKanaNm = "";
      let srPlateNo = "";
      if (this.uketsuke.srPlateAreaNm) {
        srPlateAreaNm = this.uketsuke.srPlateAreaNm;
      }
      if (this.uketsuke.srPlateModelNm) {
        srPlateModelNm = this.uketsuke.srPlateModelNm;
      }
      if (this.uketsuke.srPlateKanaNm) {
        srPlateKanaNm = this.uketsuke.srPlateKanaNm;
      }
      if (this.uketsuke.srPlateNo) {
        srPlateNo = this.uketsuke.srPlateNo;
      }
      return srPlateAreaNm + srPlateModelNm + srPlateKanaNm + srPlateNo;
    }
    return "";
  }

  get soukouUnit() {
    if (this.sknUketsukeExtends) {
      return this.sknUketsukeExtends.soukouUnitKbn == 1 ? "km" : "ﾏｲﾙ";
    }
    return "";
  }

  get strSoukou() {
    if (this.sknUketsukeExtends) {
      let soukouVal = 0;
      if (this.sknUketsukeExtends.soukouUnitKbn === 2) {
        if (this.sknUketsukeExtends.soukouMile) {
          soukouVal = this.sknUketsukeExtends.soukouMile;
        }
      } else {
        if (this.sknUketsukeExtends.soukouKm) {
          soukouVal = this.sknUketsukeExtends.soukouKm;
        }
      }
      return util.getNumberThousandSeparate(soukouVal);
    }
    return "-";
  }

  get zenkaiSoukou() {
    if (this.sknUketsukeExtends) {
      let zenkaiSoukouVal = 0;
      if (this.sknUketsukeExtends.soukouUnitKbn == 1) {
        if (this.sknUketsukeExtends.zenkaiSoukouKm) {
          zenkaiSoukouVal = +this.sknUketsukeExtends.zenkaiSoukouKm;
          return util.getNumberThousandSeparate(zenkaiSoukouVal);
        }
      } else {
        if (this.sknUketsukeExtends.zenkaiSoukouMile) {
          zenkaiSoukouVal = +this.sknUketsukeExtends.zenkaiSoukouMile;
          return util.getNumberThousandSeparate(zenkaiSoukouVal);
        }
      }
    }
    return "-";
  }

  setSoukouAvg() {
    if (this.sknUketsukeExtends) {
      let soukouKmAvg = util.calSoukouAvg(
        this.sknUketsukeExtends.soukouKm || 0,
        this.sknUketsukeExtends,
        this.uketsuke
      );
      this.updateSoukouKmAvg(soukouKmAvg);
      let soukouMileAvg = util.calSoukouMileAvg(
        this.sknUketsukeExtends.soukouMile || 0,
        this.sknUketsukeExtends,
        this.uketsuke
      );
      this.updateSoukouMileAvg(soukouMileAvg);
    }
  }

  get staffNm1() {
    if (this.customer) {
      return this.customer.staffNm1;
    }
    return "";
  }

  get frontStaff() {
    if (this.reservationState) {
      return this.reservationState.frontStaff;
    }
    return "";
  }

  get yoyakuNo(): string {
    if (this.sknUketsukeExtends && this.sknUketsukeExtends.yoyakuNo) {
      return this.sknUketsukeExtends.yoyakuNo.toString();
    }
    return "";
  }

  get workState() {
    let stateId = this.stateId;
    let objStatus: WorkProgressState = WorkProgressStateData[stateId];
    if (!this.stateId) {
      stateId = 0;
    }
    objStatus = WorkProgressStateData[stateId];

    let name = "";
    let color = "#000";
    if (objStatus != null) {
      color = objStatus.color;
      if (this.stateNm) {
        name = this.stateNm;
      } else {
        name = objStatus.text;
      }
    }
    return { color, name };
  }

  get IsHoujin(): boolean {
    if (this.uketsuke) {
      return this.uketsuke.kkKbn == 2;
    }
    return false;
  }

  updateStoreYouto() {
    this.updateOmonaYouto({
      omonaYouto: this.omonaYoutoCd,
      omonaYoutoNm: this.omonaYoutoNm
    });
  }

  changeOmonaYouto(value: any) {
    if (value) {
      const omonaYouto = this.omonaYoutos.filter(
        (e: any) => e.kbnKey === this.omonaYoutoCd
      );
      if (omonaYouto.length > 0) {
        this.omonaYoutoNm = omonaYouto[0].value;
        this.isSaveYouto = true;
        this.updateStoreYouto();
        this.reqService
          .saveOmonaYouto(
            this.service.getPutParams({ omonaYouto: omonaYouto[0].kbnKey })
          )
          .then(
            (res: any) => {
              this.$message({
                message: MESSAGE.UpdatedOmonaYouto,
                type: "info"
              });
            },
            (err: any) => {
              this.showError(err);
            }
          );
      }
    }
  }

  onYouto(frame: any) {
    if (this.isSaveYouto) {
      this.isSaveYouto = false;
    } else {
      const body = util.getWSData(frame);
      this.omonaYoutoCd = body.omonaYouto;
      this.omonaYoutoNm = body.omonaYoutoNm;
      this.updateStoreYouto();
      this.$notify.info({
        title: "Info",
        message: MESSAGE.UpdatedOmonaYouto
      });
    }
  }

  async onChangeSoukou(soukou: number) {
    const soukouUnitKbn = this.sknUketsukeExtends.soukouUnitKbn || 1;
    this.isExceed = util.checkLimitSoukou(soukou, soukouUnitKbn);
    if (this.isExceed) {
      this.errorMsg = util.msgExceedSoukou(soukouUnitKbn);
      this.$refs.errorDialog.onOpen();
    } else {
      let soukouKm = 0;
      let soukouMile = 0;
      let soukouConv: any = await this.reqService.convertMiles_Km(
        soukou,
        soukouUnitKbn.toString()
      );
      if (this.sknUketsukeExtends.soukouUnitKbn === 2) {
        soukouKm = soukouConv.miles;
        soukouMile = soukou;
      } else {
        soukouKm = soukou;
        soukouMile = soukouConv.km;
      }

      let soukouKmAvg = util.calSoukouAvg(
        soukou,
        this.sknUketsukeExtends,
        this.uketsuke
      );
      let soukouMileAvg = util.calSoukouMileAvg(
        soukouMile,
        this.sknUketsukeExtends,
        this.uketsuke
      );
      this.updateSoukouKm(soukou);
      this.updateSoukouKmAvg(soukouKmAvg);
      if (this.carSelectData) {
        this.carSelectData.soukouKm = soukouKm;
        this.carSelectData.soukouMile = soukouMile;
        this.setCarSelection(this.carSelectData);
        this.saveTempSoukou();
      }

      this.reqService
        .saveMileage(
          this.service.getPutParams({
            soukouKm: soukouKm,
            soukouKmAvg,
            soukouMile: soukouMile,
            soukouMileAvg,
            soukouUnitKbn: soukouUnitKbn,
            soukouBikouKbn: this.sknUketsukeExtends.soukouBikouKbn
          })
        )
        .then(
          (res: any) => {
            this.$message({
              message: MESSAGE.UpdatedSoukouKm,
              type: "info"
            });
          },
          (err: any) => {
            this.showError(err);
          }
        );
    }
  }

  onMileage(frame: any) {
    const body = util.getWSData(frame);
    this.updateSoukouKm(body.soukouKm);
    this.updateSoukouMile(body.soukouMile);
    this.updateSoukouUnitKbn(body.soukouUnitKbn);
    this.updateSoukouBikouKbn(body.soukouBIKOUKbn);

    this.setSoukouAvg();
    if (this.isUserMode) {
      this.$notify.info({
        title: "Info",
        message: MESSAGE.UpdatedSoukouKm
      });
    }
  }

  onFrontStaff(frame: any) {
    const body = util.getWSData(frame);
    this.onUpdateFront(body.frontTantoushaCd);
    this.$notify.info({
      title: "Info",
      message: MESSAGE.UpdatedFrontTantousha
    });
  }

  onUpdateFront(frontTantoushaCd: string) {
    let selectedStaff = this.staffs.filter(
      (staff: any) => staff.staffCd == frontTantoushaCd
    );
    if (selectedStaff.length > 0) {
      this.updateFrontStaff({
        staffCd: frontTantoushaCd,
        staffNm: selectedStaff[0].staffNm
      });
    }
  }

  onConnect() {
    clearTimeout(this.timerCheckSocket);
    this.timerCheckSocket = null;
    this.sktControll.socketExtends(this.onUpdateTime);
    this.sktControll.socketWorkProgress(this.onChangeWorkProgress);
    this.sktControll.socketReservation(this.onMileage);
    this.sktControll.socketCustomerYouto(this.onYouto);
    if (this.isUserMode) {
      this.sktControll.socketFront(this.onFrontStaff);
      this.sktControll.socketCompleted(this.onChangeWorkProgress);
    }
  }

  showError(error: any) {
    this.errorMsg = util.getHttpErrorMessage(error);
    this.$refs.errorDialog.onOpen();
  }

  getMinute(start: number, stop: number) {
    let duration = stop - start;
    if (duration > 0) {
      return Math.floor(duration / 60000);
    }
    return 0;
  }

  padMinute(num: number, isMaintenance?: boolean) {
    let pad = 3;
    let sign = "";

    if (isMaintenance && this.isMaintenanceOverExpect) {
      pad = 2;
      sign = "+";
    }
    return sign + padNumber(num.toFixed(0), pad);
  }

  //inspect time
  setInspectMinute() {
    if (this.inspectTime) {
      this.$nextTick(() => {
        this.setStrInspectMinute();
      });
    }
  }

  setStrInspectMinute() {
    this.inspectMinute = this.padMinute(this.inspectTime);
  }

  setTempInspectMinute() {
    this.setInspectTime(this.inspectTime + 1);
    let inspectMinute = this.padMinute(this.inspectTime);
    this.$set(this, "inspectMinute", inspectMinute);
  }

  setTempMaitenaceMinute() {
    this.setMaintenanceTime(this.maintenanceMinuteNum + 1);
    if (this.isMaintenanceOverExpect && this.maintenanceMinuteNum > 99) {
      this.$set(this, "maintenanceMinute", "---");
    } else {
      let maintenanceMinute = this.padMinute(this.maintenanceMinuteNum, true);
      this.$set(this, "maintenanceMinute", maintenanceMinute);
    }
  }

  // maintenance time
  setMaintenanceMinute() {
    if (this.maintenanceExpectTime) {
      this.isNotStartMaintenance = false;
      this.maintenanceMinuteNum =
        this.maintenanceExpectTime - this.maintenanceTime;
      if (this.maintenanceMinuteNum < 0) {
        this.isMaintenanceOverExpect = true;
        this.maintenanceMinuteNum = Math.abs(this.maintenanceMinuteNum);
      }
      this.$nextTick(() => {
        this.setStrMaintenanceMinute();
      });
    } else if (this.isSavePayment) {
      this.setMaintenanceZero();
    }
  }

  setMaintenanceZero() {
    if (this.maintenanceExpectTime === 0) {
      this.isNotStartMaintenance = false;
      this.maintenanceMinute = "000";
    }
  }

  stopTimerMaintenance() {
    clearInterval(this.maintenanceTimer);
    this.maintenanceTimer = null;
  }

  setStrMaintenanceMinute() {
    if (this.isMaintenanceOverExpect && this.maintenanceMinuteNum > 99) {
      this.maintenanceMinute = "---";
    } else {
      this.maintenanceMinute = this.padMinute(this.maintenanceMinuteNum, true);
    }
  }

  onUpdateTime(frame: any) {
    const body = util.getWSData(frame);
    this.setSubHeaderData(body);
    this.setInspectMinute();
    this.setMaintenanceMinute();
    this.getSubHeaderData();
  }

  onChangeWorkProgress(frame: any) {
    const body = util.getWSData(frame);
    if (
      this.isUserMode &&
      this.waitPartsSelect &&
      ( body.currentWorkProgressState == 6 || body.currentWorkProgressState == 16 ) &&
      body.screenCd == "MD0009"
    ) {
      this.updateWaitPartSelect(false);
      this.$refs.md15FinishDialog.onOpen();
      const userService = new UserService();
      userService.getSeibi();
    } else if (this.isUserMode && body.currentWorkProgressState == 14) {
      this.displayDialogCompleted = true;
    }
    this.getSubHeaderData();
  }

  onCloseMsg() {
    if (this.isExceed) {
      this.isExceed = false;
      if (this.sknUketsukeExtends) {
        this.$set(this.sknUketsukeExtends, "soukouKm", this.tempKm);
        this.$set(this.sknUketsukeExtends, "soukouMile", this.tempMile);
      }
    }
  }

  saveTempSoukou() {
    this.tempKm = this.sknUketsukeExtends.soukouKm;
    this.tempMile = this.sknUketsukeExtends.soukouMile;
    console.log(this.tempKm, this.tempMile);
  }

  destroyed() {
    this.sktControll.freeSocketResources();
    if (this.timerCheckSocket) {
      clearTimeout(this.timerCheckSocket);
      // clearInterval(this.timerManualUpdateTime);
    }
    /** 2021-06-15 sh #7190 fix bug clearInterval [START] */
    if (this.timerManualUpdateTime) {
      clearInterval(this.timerManualUpdateTime);
    }
    /** 2021-06-15 sh #7190 fix bug clearInterval [END] */ 
  }
  showSknMenuDialog() {
    this.$refs.sknMenuDialog.onOpen();
  }

  onConfirm(seibiMenuCd: string) {
    this.seibiMenuCd = seibiMenuCd;
    this.$refs.dialog.onOpen();
  }

  updateShakenShurui() {
    let inspectionDetail: InspectDetail = {
      kensain: [],
      seibishi: [],
      hojoSeibishi: []
      , uketsukeExtendId: this.uketsukeExtendsId
      , shakenShuruiSeibiMenuCd: this.seibiMenuCd
    };
    this.reqService.updateShakenShurui(inspectionDetail).then(
      (res: any) => {
        this.clearBuhin();
        this.setSeibiMenuCd(this.seibiMenuCd);
        this.$refs.sknMenuDialog.onClose();
      }
    );
  }

  get isShowMenuBtn() {
    let rst = false;
    
    if (process.env.VUE_APP_API_URL !== 'https://inspection.extreme-service.jp/skn/v1') {
      /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [START] */
      /** ボタンは、Headerに移動したため、常に非表示とする。*/
      // return true;
      return false;
      /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [END] */
    }

    return false;
  }
}
